import React from 'react'
import { Container, FormRow } from '../../../components'

const ContentSection = ({data}) => {
  return (
    <Container className="pt-8 lg:pt-24">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-7/12 px-4 mb-8 lg:mb-0">
          {
            data.content &&
            <div className={`blog-content ${data.video ? 'mb-4 lg:mb-8' : ''}`} dangerouslySetInnerHTML={{
              __html: data.content
            }} />
          }
          {
            data.video &&
            <iframe title="youtubeembed" width="100%" height="480" src={data.video} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          }
        </div>
        <div className="w-full lg:w-4/12 px-4 lg:ml-auto text-sm">
          <FormRow>
            <p className="font-bold mb-2">Date and Time</p>
            <div className="text-gray-444" dangerouslySetInnerHTML={{
              __html: data.dateAndTime
            }} />
          </FormRow>
          <FormRow>
            <p className="font-bold mb-2">Location</p>
            <div className="text-gray-444" dangerouslySetInnerHTML={{
              __html: data.location
            }} />
          </FormRow>
        </div>
      </div>
    </Container>
  )
}

export { ContentSection }
